import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "small striped toggle no-underline overflow-auto" }
const _hoisted_2 = { class: "large large_padding" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, [
  /*#__PURE__*/_createTextVNode(" EIN "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" / Tax ID ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, [
  /*#__PURE__*/_createTextVNode(" Company "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Name ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, [
  /*#__PURE__*/_createTextVNode(" Employer "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" / Payor ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, [
  /*#__PURE__*/_createTextVNode(" First "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Name ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, [
  /*#__PURE__*/_createTextVNode(" Last "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Name ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, " Title ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, [
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Address ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, " Phone ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, " Type ", -1)
const _hoisted_12 = {
  key: 0,
  class: "col-md-1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-1" }
const _hoisted_15 = { class: "col-md-1" }
const _hoisted_16 = { class: "col-md-1" }
const _hoisted_17 = { class: "col-md-1" }
const _hoisted_18 = { class: "col-md-1" }
const _hoisted_19 = { class: "col-md-1" }
const _hoisted_20 = { class: "col-md-2" }
const _hoisted_21 = { class: "col-md-1" }
const _hoisted_22 = { class: "col-md-1" }
const _hoisted_23 = {
  key: 0,
  class: "col-md-1"
}
const _hoisted_24 = { class: "actions" }
const _hoisted_25 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Send PIN"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, " / ", -1)
const _hoisted_28 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Reject Request"
}
const _hoisted_29 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", null, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        (_ctx.processed == 0)
          ? (_openBlock(), _createElementBlock("th", _hoisted_12, [
              _createTextVNode(" Account "),
              _hoisted_13,
              _createTextVNode(" actions")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employers, (employer) => {
        return (_openBlock(), _createElementBlock("tr", {
          class: "large",
          key: employer.TaxID
        }, [
          _createElementVNode("td", _hoisted_14, _toDisplayString(employer.TaxID), 1),
          _createElementVNode("td", _hoisted_15, _toDisplayString(employer.CompanyName), 1),
          _createElementVNode("td", _hoisted_16, _toDisplayString(employer.Type), 1),
          _createElementVNode("td", _hoisted_17, _toDisplayString(employer.FirstName), 1),
          _createElementVNode("td", _hoisted_18, _toDisplayString(employer.LastName), 1),
          _createElementVNode("td", _hoisted_19, _toDisplayString(employer.Title), 1),
          _createElementVNode("td", _hoisted_20, _toDisplayString(employer.Email), 1),
          _createElementVNode("td", _hoisted_21, _toDisplayString(employer.Phone), 1),
          _createElementVNode("td", _hoisted_22, _toDisplayString(employer.Role), 1),
          (_ctx.processed == 0)
            ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, [
                    _createElementVNode("i", {
                      class: "plan-modal iatse-icon-lock-check",
                      onClick: ($event: any) => (_ctx.sendPin(employer.UIEmployerRequestID))
                    }, null, 8, _hoisted_26)
                  ]),
                  _hoisted_27,
                  _createElementVNode("span", _hoisted_28, [
                    _createElementVNode("i", {
                      class: "plan-modal iatse-icon-lock",
                      onClick: ($event: any) => (_ctx.rejectRequest(employer.UIEmployerRequestID))
                    }, null, 8, _hoisted_29)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}